type Amounts = {
    netAmount?: number | null;
    grossAmount?: number | null;
};

export function getDisplayAmount(
    pricesIncludeVat: boolean | null | undefined,
    amounts: Amounts | null | undefined,
): number | null | undefined {
    if (!amounts) {
        return amounts;
    }

    return pricesIncludeVat === false ? amounts.grossAmount : amounts.netAmount;
}
